import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["existingSection", "newSection", "existingSelect", "newEmail", "existingCheck", "newCheck"]

  connect() {
    this.toggleType()
  }

  toggleType() {
    const selectedType = this.element.querySelector('input[name="invite_type"]:checked')?.value

    if (selectedType === "existing") {
      this.showExisting()
    } else {
      this.showNew()
    }
  }

  showExisting() {
    if (this.hasExistingSectionTarget) {
      this.existingSectionTarget.classList.remove("hidden")
    }
    if (this.hasNewSectionTarget) {
      this.newSectionTarget.classList.add("hidden")
    }
    if (this.hasExistingSelectTarget) {
      this.existingSelectTarget.disabled = false
    }
    if (this.hasNewEmailTarget) {
      this.newEmailTarget.disabled = true
      this.newEmailTarget.value = ""
    }
    if (this.hasExistingCheckTarget) {
      this.existingCheckTarget.classList.remove("hidden")
    }
    if (this.hasNewCheckTarget) {
      this.newCheckTarget.classList.add("hidden")
    }
  }

  showNew() {
    if (this.hasExistingSectionTarget) {
      this.existingSectionTarget.classList.add("hidden")
    }
    if (this.hasNewSectionTarget) {
      this.newSectionTarget.classList.remove("hidden")
    }
    if (this.hasExistingSelectTarget) {
      this.existingSelectTarget.disabled = true
      this.existingSelectTarget.value = ""
    }
    if (this.hasNewEmailTarget) {
      this.newEmailTarget.disabled = false
    }
    if (this.hasExistingCheckTarget) {
      this.existingCheckTarget.classList.add("hidden")
    }
    if (this.hasNewCheckTarget) {
      this.newCheckTarget.classList.remove("hidden")
    }
  }
}
